import GlobalStyles from "./components/GlobalStyle/GlobalStyles.js";
import * as serviceWorker from "./serviceWorker";

import React from "react";
import ReactDOM from "react-dom/client"; // ✅ React 18 dùng 'react-dom/client'
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GlobalStyles>
    <App />
  </GlobalStyles>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
